export interface Task {
  id: string;
  type: string;
  taskStatus: TaskStatus;
  inserted: string;
}

export interface TaskStatus {
  status: string;
  message: string;
}

export const taskToRow = (t: Task) => {
  return {
    key: t.id,
    id: t.id,
    type: t.type,
    inserted: t.inserted,
    status: t.taskStatus.status,
    message: t.taskStatus.message,
  };
};

export interface TaskRow {
  key: string;
  id: string;
  type: string;
  inserted: string;
  status: string;
  message: string;
}
